import React, { useEffect, useRef, useState } from "react";
import {
  API_ENDPOINTS,
  formatStringKey,
  TERMS,
} from "../../constant/_constant";
import usePostRequest from "../../hooks/usePostRequest";
import Filters from "./FiltersModal/Filters";
import * as XLSX from "xlsx";
import {
  Form,
  Table,
  Card,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Button,
  InputGroup,
  Dropdown,
  Accordion,
  Toast,
} from "react-bootstrap";
import { pdf } from "@react-pdf/renderer";
import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
import {
  IconUserShare,
  IconUserOff,
  IconTrash,
  IconCircle,
  IconCircleCheckFilled,
  IconUserCheck,
  IconEdit,
  IconCopy,
  IconMailSpark,
  IconMailForward,
  IconUsers,
  IconX,
  IconBuildings,
  IconFileTypePdf,
  IconHistory,
  IconProgressCheck,
  IconArrowsSort,
  IconHistoryToggle,
  IconFilter,
  IconFileTypeXls,
  IconPaperclip,
  IconFileSearch,
  IconBox,
  IconMessageCircle,
  IconUserPin,
  IconAddressBook,
  IconMessage,
  IconTriangle,
  IconRotateClockwise,
  IconBackspace,
  IconSearch,
  IconCalendarWeek,
  IconEye,
  IconSortAscending,
  IconLayoutGridFilled,
  IconLayoutListFilled,
  IconRefreshDot,
  IconSquareArrowRight,
} from "@tabler/icons-react";
import DynamicPagination from "../../components/DynamicPagination ";
import useDebounce from "../../hooks/useDebounce";
import moment from "moment";
import { getAbbreviation } from "../../utils/_helpers";
import { toast } from "react-toastify";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-blue/theme.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import ConfirmationModal from "../../components/ConfirmationModal";
import userp from "../../assets/user_avtar.svg";
// import ActivateUser from "./ActivateUser";
import { useSelector } from "react-redux";
import { hasPermission } from "../../utils/_helpers";
import { useNavigate, createSearchParams, useLocation } from "react-router-dom";
import SKU_Version_POPUP from "./SKU_Version_POPUP";
import GetRFQHistoryPOP_UP from "./GetRFQHistoryPOP_UP";
import ExcelDialog from "./ExcelDialog";
import PdfDocument from "./PDF/main";
import KOorCustomerEmailDialog from "./Email/KOorCustomerEmailDialog";
import SuccsessMsgModal from "../../components/SuccessMsgModal";
import EmailQuoteDialog from "./Email/EmailQuoteDialog";
import EmailHistory from "./Email/EmailHistory";
// import CopyEmailDialog from "./CopyEmailDialog.js/CopyEmailDialog";
import View_DetailsOpportunity from "./ViewDetail/View_DetailsOpportunity";
import Lottie from "lottie-react";
import WinData from "../../assets/won-status.json";
import { subYears } from "date-fns/subYears";
import TableListing from "./TableListing";
import DeletePopup from "./DeleteRecord/DeletePopup";
import ComanConfirmationModal from "../../components/ComanConfirmationModal";
import CreateOrder from "./OrderPopup/CreateOrder";
import useIdleLogout from "../../hooks/useIdleLogout";
import RfqWonPopup from "./EditWonInfo/RfqWonPopup";
import { useDispatch } from "react-redux";
import { setOrderType } from "../../redux/orderReducer";
import CreateOrderEditRfq from "./OrderPopup/CreateOrderEditRfq";
import { TreeSelect } from "primereact/treeselect";
import axiosInstance from "../../api/axiosInstance";
import Loader from "../../components/Loader";

const getSavedFilters = () => {
  try {
    const saved = localStorage.getItem("opportunity_filters");
    return saved ? JSON.parse(saved) : null;
  } catch {
    return null;
  }
};

const OpportunityListing = () => {
  const savedFilters = getSavedFilters();
  const todayDate = new Date();
  const oneYearAgo = subYears(todayDate, 1);
  const [page, setPage] = useState({
    won: 1,
    draft: 1,
    paymentSuccess: 1,
    lost: 1,
    pending: 1,
    cancelled: 1,
  });

  const [limit, setLimit] = useState(10);
  const [rfqSku, setRfqSku] = useState("");
  const [hasMoreWon, setHasMoreWon] = useState(true);
  const [hasMorePaymentSuccess, setHasMorePaymentSuccess] = useState(true);
  const [hasMoreDraft, setHasMoreDraft] = useState(true);
  const [hasMorePending, setHasMorePending] = useState(true);
  const [hasMoreCancelled, setHasMoreCancelled] = useState(true);
  const [highlightedOrders, setHighlightedOrders] = useState([]);
  const [hasMoreLost, setHasMoreLost] = useState(true);
  const [sortOption, setSortOption] = useState(
    savedFilters?.sortOption || "recently_updated",
  );
  const [isListView, setIsListView] = useState(false);
  const [listViewSearchTrigger, setListViewSearchTrigger] = useState(0);
  const [showCreateOrder, setShowCreateOrder] = useState(false);
  const [showAddVendor, setShowAddVendor] = useState(false);
  const [WonRfqID, setWonRfqID] = useState("");
  const [errorProducts, setErrorProducts] = useState([]);
  const [errorRfq, setErrorRfq] = useState("");
  const [showCreateOrderRfq, setShowCreateOrderRfq] = useState(false);
  const [createOrderRfqId, setCreateOrderRfqId] = useState(null);

  const [isCopyQuoteOpen, setIsCopyQuoteOpen] = useState({
    show: false,
    Feild: "",
    rfq_id: "",
    btnText: "",
    label: "",
  });

  const statusOptions = [
    { label: "Draft", value: "DRAFT" },
    { label: "Pending", value: "PENDING" },
    // { label: "Payment Successful", value: "PAYMENT_SUCCESSFUL" },
    { label: "Won", value: "WON" },
    { label: "Lost", value: "LOST" },
    { label: "Cancelled", value: "CANCELLED" },
  ];

  const sortOptionsMap = {
    recently_updated: {
      sort_by: "updated_at",
      sort_order: "desc",
      label: "Recently updated",
    },
    created_date_closest: {
      sort_by: "created_at",
      sort_order: "desc",
      label: "Created date closest to now",
    },
    created_date_farthest: {
      sort_by: "created_at",
      sort_order: "asc",
      label: "Created date farthest from now",
    },
  };

  const handleSortChange = (sortKey) => {
    setSortOption(sortKey);
    setPage({
      draft: 1,
      won: 1,
      paymentSuccess: 1,
      lost: 1,
      pending: 1,
      cancelled: 1,
    });
    setDraftData([]);
    setPendingData([]);
    setWonData([]);
    setLostData([]);
    setCancelledData([]);
    setPaymentSuccessData([]);
    setActiveStatuses([]);
    setIsInitialLoad(false);
    setIsContentSearching(true);
    setIsSearchClicked(true);
    setListViewSearchTrigger((prev) => prev + 1);
  };

  const [isSuccsessModalOpen, setIsSuccsessModalOpen] = useState({
    show: false,
    message: "",
    btntext: "Close",
    title: "Succsess",
  });

  const [isModalOpen, setIsModalOpen] = useState({
    show: false,
  });

  const [isHistoryOpen, setIsHistoryOpen] = useState({
    show: false,
  });

  const [isExcelOpen, setIsExcelOpen] = useState({
    show: false,
  });

  const [isEmaillOpen, setIsEmaillOpen] = useState({
    title: "",
    show: false,
    row: "",
    skuData: "",
    defaultSubject: "",
    Quote_No: "",
    RFQID: "",
    toEmail: "",
    toName: "",
  });

  const [isEmailQuoteOpen, setIsEmailQuoteOpen] = useState({
    show: false,
    Quote_No: "",
    rfq_id: "",
  });

  const [isModalStatusOpen, setIsModalStatusOpen] = useState({
    show: false,
    action: null,
    message: "",
  });

  const [isViewOpen, setIsViewOpen] = useState({
    show: false,
    products: [],
    isStatusUpdate: false,
  });

  const [isEmailHistoryOpen, setIsEmailHistoryOpen] = useState({
    show: false,
    rfq_id: "",
  });

  // const [searchDebounce, setSearchDebounce] = useState({
  //   searchInvoice: "",
  //   searchOpportunityName: "",
  // });

  const triggerCardHighlight = (rfq_id) => {
    setHighlightedOrders((prev) => [...prev, rfq_id]);
    setTimeout(() => {
      setHighlightedOrders((prev) => prev.filter((id) => id !== rfq_id));
    }, 3000);
  };

  const handleSKUVERSION_OPEN = (e, rfq) => {
    e.preventDefault();
    setRfqSku(rfq);
    setIsModalOpen({ show: true });
  };
  const handleHistoryOpen = (e, rfq) => {
    e.preventDefault();
    setRfqSku(rfq);
    setIsHistoryOpen({ show: true });
  };

  const [isKOorCustomerDialogOpen, setIsKOorCustomerDialogOpen] =
    React.useState(false);

  // filter
  // const searchInputRef = useRef();
  // const [search, setSearch] = useState("");
  const filterBtnRef = useRef(null);
  const [searchInput, setSearchInput] = useState("");
  // const [salesHeadFilter, setSalesHeadFilter] = useState("");
  // const [contractFilter, setContractFilter] = useState("");
  const [orderTypeFilter, setOrderTypeFilter] = useState(
    savedFilters?.orderTypeFilter || "",
  );
  const [paymentTypeFilter, setPaymentTypeFilter] = useState(
    savedFilters?.paymentTypeFilter || "",
  );
  const [vendorFilter, setVendorFilter] = useState(
    savedFilters?.vendorFilter || "",
  );
  const [vendorName, setVendorName] = useState(savedFilters?.vendorName || "");
  const [selectedProductsFilter, setSelectedProductsFilter] = useState(
    savedFilters?.selectedProductsFilter || [],
  );
  const [publishedFrom, setPublishedFrom] = useState(
    savedFilters?.publishedFrom ? new Date(savedFilters.publishedFrom) : null,
  );
  const [publishedTo, setPublishedTo] = useState(
    savedFilters?.publishedTo ? new Date(savedFilters.publishedTo) : null,
  );
  const [dueDateFrom, setDueDateFrom] = useState(
    savedFilters?.dueDateFrom ? new Date(savedFilters.dueDateFrom) : null,
  );
  const [dueDateTo, setDueDateTo] = useState(
    savedFilters?.dueDateTo ? new Date(savedFilters.dueDateTo) : null,
  );
  const [globalTotal, setGlobalTotal] = useState(
    savedFilters?.globalTotal || 0,
  );
  const [filteredTotal, setFilteredTotal] = useState(0);
  // const [isSearchClicked, setIsSearchClicked] = useState(false);
  const [isContentSearching, setIsContentSearching] = useState(false);
  const [openSubstatusDropdown, setOpenSubstatusDropdown] = useState(null);
  // filter

  const [search, setSearch] = useState(savedFilters?.search || "");
  const navigate = useNavigate();
  const [salesHeadFilter, setSalesHeadFilter] = useState(
    savedFilters?.salesHeadFilter || "",
  );
  const [selectedStatus, setSelectedStatus] = useState(
    savedFilters?.selectedStatus || [],
  );
  const [contractFilter, setContractFilter] = useState(
    savedFilters?.contractFilter || "",
  );

  const [statusFilter, setStatusFilter] = useState("");
  const [isInitialLoad, setIsInitialLoad] = useState(!savedFilters);
  const [paymentSuccessData, setPaymentSuccessData] = useState([]);
  const [wonData, setWonData] = useState([]);
  const [draftData, setDraftData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [cancelledData, setCancelledData] = useState([]);
  const [lostData, setLostData] = useState([]);
  const [startDate, setStartDate] = useState(
    savedFilters?.startDate ? new Date(savedFilters.startDate) : null,
  );
  const [endDate, setEndDate] = useState(
    savedFilters?.endDate ? new Date(savedFilters.endDate) : null,
  );
  const [isSearchClicked, setIsSearchClicked] = useState(!!savedFilters);
  const [activeStatuses, setActiveStatuses] = useState([]);

  const [show, setShow] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);

  const [showFiltersModal, setShowFiltersModal] = useState(false);

  const StatusList = [
    "Pending",
    // "Payment Successful",
    "Won",
    "Lost",
    "Cancelled",
    "Draft",
  ];

  const handleTabClick = (step) => {
    setCurrentStep(step);
  };

  useIdleLogout();

  useEffect(() => {
    setExcelData([
      ...wonData,
      ...draftData,
      ...pendingData,
      ...paymentSuccessData,
      ...cancelledData,
      ...lostData,
    ]);
  }, [
    wonData,
    draftData,
    pendingData,
    cancelledData,
    lostData,
    paymentSuccessData,
  ]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const user = useSelector((state) => state.auth.user);

  const location = useLocation();
  const dispatch = useDispatch();

  // check perminssion
  const hasPermission = (permissionArray, permissionType) =>
    permissionArray.includes(permissionType);

  const specificAdminEmail = "andrii@aspettoinc.com";
  // andrii@aspettoinc.com
  const userIsAdmin = user?.email === specificAdminEmail;
  const userAssignRole = user?.permissions?.manage_role || [];
  const canDeleteUser = hasPermission(userAssignRole, "delete");
  const canAssignRole = hasPermission(userAssignRole, "write");
  // check perminssion

  // const { postData: fetchOpportunity, data } = usePostRequest(
  //   API_ENDPOINTS.LISTING_OPPORTUNITIES
  // );

  const { loadingdownLoad, postData: DownLoadFile } = usePostRequest(
    API_ENDPOINTS.DownLoadFile,
  );

  const { loadingDelete, postData: deleteRecord } = usePostRequest(
    API_ENDPOINTS.DELETE_RECORD_RFQ,
  );

  const {
    data: wonres,
    isLoading: loadingWon,
    postData: fetchOpportunityWon,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);
  const {
    data: lostres,
    isLoading: loadingLost,
    postData: fetchOpportunityLost,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);
  const {
    data: paymentSuccessres,
    isLoading: loadingPaymentSuccess,
    postData: fetchOpportunityPaymentSuccess,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);

  const {
    data: draftres,
    isLoading: loadingDraft,
    postData: fetchOpportunityDraft,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);

  const {
    data: penddingres,
    isLoading: loadingPending,
    postData: fetchOpportunityPending,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);
  const {
    data: cancelledres,
    isLoading: loadingCancelled,
    postData: fetchOpportunityCancelled,
  } = usePostRequest(API_ENDPOINTS.LISTING_OPPORTUNITIES);
  const {
    data: contractData,
    isLoading,
    postData: fetchContract,
  } = usePostRequest(API_ENDPOINTS.GET_CONTRACT);

  const { data: SalesHead, postData: fetchRfq } = usePostRequest(
    API_ENDPOINTS.GET_RFQ_USERS,
  );

  const { isLoading: removeLoading, postData: statusChange } = usePostRequest(
    API_ENDPOINTS.OPPORTUNITY_STATUS,
  );

  // useEffect(() => {
  //   const handleBeforeUnload = () => {
  //     sessionStorage.setItem("is_reloading", "true");
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);

  //     const isReloading = sessionStorage.getItem("is_reloading");

  //     if (!isReloading) {
  //       localStorage.removeItem("opportunity_filters");
  //     } else {
  //       sessionStorage.removeItem("is_reloading");
  //     }
  //   };
  // }, []);

  const [viewType, setViewType] = useState(() => {
    return localStorage.getItem("viewType") || "general";
  });
  const handleViewChange = (view) => {
    // setViewType(view);
    // setLifecycleData({});
    // setIsContentSearching(true);
    // setIsInitialLoad(false);
    // setIsSearchClicked(true);
    // setPaginationState({});
    // setHasMoreData({});
  };

  useEffect(() => {
    const navigationEntries = performance.getEntriesByType("navigation");
    const isReload =
      navigationEntries.length > 0 && navigationEntries[0].type === "reload";
    return () => {
      if (!isReload) {
        localStorage.removeItem("opportunity_filters");
      }
    };
  }, []);

  // Reload fnx. for localstorage clearance on filter.
  useEffect(() => {
    sessionStorage.removeItem("is_reloading");

    const handleBeforeUnload = () => {
      sessionStorage.setItem("is_reloading", "true");
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      const isReloading = sessionStorage.getItem("is_reloading");

      if (!isReloading) {
        localStorage.removeItem("opportunity_filters");
      } else {
        sessionStorage.removeItem("is_reloading");
      }
    };
  }, []);

  // filter

  useEffect(() => {
    localStorage.setItem("isListView", JSON.stringify(isListView));
  }, [isListView]);
  const handleListViewChange = (value) => {
    setIsListView(value);
    localStorage.setItem("isListView", JSON.stringify(value));
  };

  // const { debounceSearch } = useDebounce(search);

  const handleGenerateExcel = (selectedFields) => {
    try {
      if (!excelData || excelData?.length === 0) {
        throw new Error("No data available to export");
      }
      if (!selectedFields || selectedFields.length === 0) {
        throw new Error("No fields selected for export");
      }

      const formattedData = excelData?.map((row, index) => {
        const filteredRow = {};
        selectedFields.forEach((field) => {
          switch (field) {
            case "Opportunity Name":
              filteredRow[field] = row?.opportunity_name || "";
              break;
            case "Quote No":
              filteredRow[field] = row.rfq_id || "";
              break;
            case "Contract Vehicle":
              filteredRow[field] = row.ContractType.name || "";
              break;
            case "KO name":
              filteredRow[field] = row.rfqKo.name || "";
              break;
            case "KO email":
              filteredRow[field] = row.rfqKo.email || "";
              break;
            case "KO phone":
              filteredRow[field] = row.rfqKo.phone || "";
              break;
            case "KO address":
              filteredRow[field] = row.rfqKo.address || "";
              break;
            case "Published Date":
              filteredRow[field] = row.published_date
                ? moment(row.published_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Due Date":
              filteredRow[field] = row.due_date
                ? moment(row.due_date).format("MM/DD/YYYY")
                : "";
              break;
            case "Opportunity Description":
              filteredRow[field] = row.brief;
              break;
            case "Organization Name":
              filteredRow[field] = row.organization_name;
              break;

            // case "General Notes":
            //   const GEN_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "GEN"
            //   );

            //   filteredRow[field] = GEN_NOTES?.description;
            //   break;

            // case "Billing & Shipping Notes":
            //   const BS_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "BS"
            //   );

            //   filteredRow[field] = BS_NOTES?.description;
            //   break;
            // case "Purchase Orders Notes":
            //   const POD_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "POD"
            //   );

            //   filteredRow[field] = POD_NOTES?.description;
            //   break;
            // case "Contracting Officer Notes":
            //   const CO_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "CO"
            //   );

            //   filteredRow[field] = CO_NOTES?.description;
            //   break;
            // case "Sales Notes":
            //   const SALE_NOTES = row.RfqNotes.find(
            //     (notes) => notes.type === "SALE"
            //   );
            //   filteredRow[field] = SALE_NOTES?.description;
            //   break;

            case "Customer Name":
              filteredRow[field] = row.rfqShipping.name;
              break;
            case "Customer Email":
              filteredRow[field] = row.rfqShipping.email;
              break;
            case "Customer Phone":
              filteredRow[field] = row.rfqShipping.phone;
              break;
            case "Customer Address":
              filteredRow[field] = row.rfqShipping.address;
              break;
            case "Shipping Method":
              filteredRow[field] = row.shipping_method;
              break;
            case "Sales Head Name":
              filteredRow[field] = row.sales_lead_name;
              break;
            case "Sales Head Email":
              filteredRow[field] = row.sales_lead_email;
              break;
            case "Sales Head Ph":
              filteredRow[field] = row.sales_lead_phone;
              break;
            case "Shipping Terms":
              filteredRow[field] = row.shipping_term ? row.shipping_term : "";
              break;
            case "Estimated Delivery":
              filteredRow[field] = row.estimated_delivery;
              break;
            case "Payment Terms":
              const selectedTerm = TERMS.Term.find(
                (term) => term.Id === row.payment_term,
              );
              if (selectedTerm) {
                filteredRow[field] = selectedTerm.Name;
              }
              break;
            case "Other Cost": {
              if (row.other_cost_json) {
                try {
                  const otherCosts = Array.isArray(row.other_cost_json)
                    ? row.other_cost_json
                    : JSON.parse(row.other_cost_json);

                  otherCosts.forEach((cost, idx) => {
                    if (cost.Name || cost.Amount) {
                      // Only add if either Name or Amount exists
                      if (cost.Name) {
                        filteredRow[`Other Cost Name${idx + 1}`] = cost.Name;
                      }
                      if (cost.Amount) {
                        filteredRow[`Other Cost ${idx + 1}($)`] = cost.Amount;
                      }
                    }
                  });
                } catch (e) {
                  console.error("Error parsing other_cost_json:", e);
                }
              }
              break;
            }
            case "Shipping Cost($)":
              filteredRow[field] = row.shipping_cost;
              break;
            case "Tax($)":
              filteredRow[field] = row.tax;
              break;
            case "Total Cost($)":
              filteredRow[field] = row.total_cost_before_margin;
              break;
            case "Total Price($)":
              filteredRow[field] = row.total_cost_after_margin;
              break;
            case "Created Date":
              filteredRow[field] = row.created_at
                ? moment(row.created_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Last Updated Date":
              filteredRow[field] = row.updated_at
                ? moment(row.updated_at).format("MM/DD/YYYY")
                : "";
              break;
            case "Status":
              filteredRow[field] = row.status;
              break;
            default:
              filteredRow[field] = "";
              break;
          }
        });
        return filteredRow;
      });

      if (formattedData.length === 0) {
        throw new Error("No valid data to export");
      }

      // Create a new workbook and worksheet
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(formattedData);

      XLSX.utils.book_append_sheet(wb, ws, "ASPETTO SALES");
      const today = new Date(); // Get current date
      const excelFileName =
        "ASPETTO SALES-" +
        String(today).split("T")[0] +
        "(" +
        "STATUS:" +
        "" +
        ")" +
        ".xlsx"; // Generate file name
      XLSX.writeFile(wb, excelFileName); // Write Excel file to disk
      console.log("Excel file generated successfully");
    } catch (error) {
      console.error("Error generating Excel file:", error.message);
      alert(error.message); // Display error to the user
    }
  };

  const stickyRef = useRef(null);
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (stickyRef.current) {
        const offsetTop = stickyRef.current.offsetTop;
        setIsFixed(window.scrollY > offsetTop);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const PD = new Date();
  const today = new Intl.DateTimeFormat("en-US", {
    dateStyle: "medium",
  }).format(PD);

  const HandlePDFClick = async (row) => {
    console.log("row ka data ", row);

    const OP_arr = String(`Quote`).split(".");
    for (var i = 0; i < OP_arr.length; i++) {
      OP_arr[i] = OP_arr[i].charAt(0).toUpperCase() + OP_arr[i].slice(1);
    }

    const sanitizeAddress = (address) => {
      if (!address) return [];
      return address
        .split("\n") // split by newline
        .map((line) => line.replace(/\t+/g, " ").trim()) // replace tabs with space, trim
        .filter((line) => line.length > 0);
    };

    const updatedInvoiceData = {
      // ...InvoiceData,
      invoice_num: String(row.rfq_id),
      Contract_Vehicle: row.ContractType.name,
      KO_name: row.rfqKo.name,
      KO_email: row.rfqKo.email,
      KO_phone: row.rfqKo.phone,
      KO_address: sanitizeAddress(row.rfqKo.address),
      Print_Date: String(today),
      trans_date: String(row.updated_at).split("T")[0],
      due_date: row.due_date,
      Valid_For: row.valid_for,
      Address:
        "ASPETTO INC, 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA",
      items: row.RfqProducts,
      Tax: row.tax,
      Shipping_Cost: row.shipping_cost,
      Total_Cost: row.total_cost_after_margin,
      Other_Cost: row.other_cost_json,
      BillTo_Phone: row.rfqBilling.phone,
      BillTo_Name: row.rfqBilling.name,
      BillTo_Address: sanitizeAddress(row.rfqBilling.address),
      BillTo_Email: row.rfqBilling.email,
      Notes: row.RfqNotes,
      Shipping_Details: {
        Organization_Name: row.organization_name,
        KO_name: row.rfqKo.name,
        Sales_Head_Info: {
          Name: row.sales_lead_name, //formatStringKey
          Email: row.sales_lead_email,
          Phone: row.sales_lead_phone,
        },
        Customer_Name: row.rfqShipping.name, // formatStringKey
        Customer_Email: row.rfqShipping.email,
        Customer_Phone: row.rfqShipping.phone,
        Customer_Address: sanitizeAddress(row.rfqShipping.address),
        Shipping_Method: row.shipping_method,
        Shipping_Method_Detail: row.shipping_method_detail,
        Shipping_Terms: row.shipping_term,
        Estimated_Delivery: row.estimated_delivery,
        Payment_Terms: row.payment_term,
        Payment_Terms_Details: row.payment_term_detail,
      },
    };

    // setInvoiceData(updatedInvoiceData);
    //  Format Opportunity Name for file name
    let File_Opportunity_Name = "";

    File_Opportunity_Name = OP_arr.join(" ");

    setTimeout(async () => {
      try {
        console.log("1. Starting PDF generation");
        console.log("2. updatedInvoiceData:", updatedInvoiceData);
        console.log("3. items count:", updatedInvoiceData.items?.length);
        console.log(
          "4. Tax:",
          updatedInvoiceData.Tax,
          "Shipping:",
          updatedInvoiceData.Shipping_Cost,
        );
        console.log("5. Other_Cost raw:", updatedInvoiceData.Other_Cost);
        console.log("6. Total_Cost:", updatedInvoiceData.Total_Cost);
        console.log(
          "7. Shipping_Details:",
          updatedInvoiceData.Shipping_Details,
        );
        console.log("8. KO_name:", updatedInvoiceData.KO_name);
        console.log("9. BillTo_Name:", updatedInvoiceData.BillTo_Name);

        const pdfBlob = await pdf(
          <PdfDocument invoicedata={updatedInvoiceData} />,
        ).toBlob();

        console.log("10. PDF blob generated successfully");

        const url = URL.createObjectURL(pdfBlob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${File_Opportunity_Name} ${String(row.rfq_id).split(".")[0]}.pdf`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (err) {
        console.error("PDF FAILED AT:", err);
        console.error("Error stack:", err.stack);
      }
    }, 0);
    // setTimeout(async () => {
    //   // setLoading(true);
    //   const pdfBlob = await pdf(
    //     <PdfDocument invoicedata={updatedInvoiceData} />,
    //   ).toBlob();

    //   const url = URL.createObjectURL(pdfBlob);

    //   const a = document.createElement("a");
    //   a.href = url;
    //   a.download = `${File_Opportunity_Name} ${String(row.rfq_id).split(".")[0]
    //     }.pdf`;
    //   document.body.appendChild(a);
    //   console.log("2", a.download);
    //   a.click();
    //   document.body.removeChild(a);
    //   URL.revokeObjectURL(url);
    // }, 0);
  };

  const searchInputRef = useRef();

  // const handleSearch = () => {
  //   const searchValue = searchInputRef.current.value?.trim();

  //   setPage(() => ({
  //     draft: 1,
  //     won: 1,
  //     lost: 1,
  //     cancelled: 1,
  //     pending: 1,
  //   }));

  //   const isAnyFilterActive =
  //     searchValue.length > 0 ||
  //     salesHeadFilter !== "" ||
  //     contractFilter !== "" ||
  //     startDate !== null ||
  //     endDate !== null;

  //   if (!isAnyFilterActive) {
  //     toast.warning(
  //       "Please select at least one search filter or input before proceeding."
  //     );
  //     return;
  //   }

  //   setSearch(searchValue);
  //   setIsSearchClicked(true);
  //   setPage((prev) => ({ ...prev, won: 1 }));
  // };

  const handleSearch = () => {
    setActiveStatuses([]);
    const searchValue = searchInput.trim();
    // Check if only one of the dates is selected
    if ((startDate && !endDate) || (!startDate && endDate)) {
      toast.warning("Please select both the dates.");
      return;
    }

    // const isAnyFilterActive =
    //   searchValue.length > 0 ||
    //   salesHeadFilter !== "" ||
    //   contractFilter !== "" ||
    //   selectedStatus.length > 0 ||
    //   (startDate !== null && endDate !== null);

    // if (!isAnyFilterActive) {
    //   toast.warning(
    //     "Please select at least one search filter or input before proceeding."
    //   );
    //   return;
    // }

    // Reset pages for all statuses
    setPage(() => ({
      draft: 1,
      won: 1,
      lost: 1,
      paymentSuccess: 1,
      cancelled: 1,
      pending: 1,
    }));

    setSearch(searchValue);
    setIsInitialLoad(false);
    setIsContentSearching(true);
    setIsSearchClicked(true);
    setListViewSearchTrigger((prev) => prev + 1);
  };

  const handleContractFilter = (e) => {
    setContractFilter(e.target.value);
    setPage((prev) => ({ ...prev, won: 1 }));
  };

  const handlesalesHeadFilter = (e) => {
    setSalesHeadFilter(e.target.value);
    setPage((prev) => ({ ...prev, won: 1 }));
  };

  // const handleSelectStatus = (e) => {
  //   const selectedOptions = Array.from(
  //     e.target.selectedOptions,
  //     (option) => option.value
  //   );

  //   setSelectedStatus((prevStatus) => {
  //     return [...new Set([...prevStatus, ...selectedOptions])];
  //   });

  //   console.log("Selected statuses are", selectedStatus);
  // };

  // useEffect(() => {
  //   console.log("The values are ", selectedStatus);
  // }, [selectedStatus]);

  const handleStatusFilter = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleClearFilter = (e) => {
    localStorage.removeItem("opportunity_filters");
    localStorage.removeItem("opportunityFilterPanel");
    setSalesHeadFilter("");
    setContractFilter("");
    setStatusFilter("");
    setSelectedStatus([]);
    setSearch("");
    setSearchInput("");
    setStartDate(null);
    setEndDate(null);
    setSortOption("recently_updated");
    setOrderTypeFilter("");
    setPaymentTypeFilter("");
    setVendorFilter("");
    setVendorName("");
    setSelectedProductsFilter([]);
    setPublishedFrom(null);
    setPublishedTo(null);
    setDueDateFrom(null);
    setDueDateTo(null);
    setPage(() => ({
      draft: 1,
      won: 1,
      lost: 1,
      paymentSuccess: 1,
      cancelled: 1,
      pending: 1,
    }));

    // Trigger dependency so the original data is fetched again
    setIsInitialLoad(true);
    setIsSearchClicked(true);
    setListViewSearchTrigger((prev) => prev + 1);
  };

  // const handleOpenKOorCustomerEmailOpenDialog = (e) => {
  //   e.preventDefault();
  //   setIsEmaillOpen({ show: true });
  // };

  const onSuccessfulFetchOpportunityWon = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreWon(false);
    }

    setWonData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };

  const onSuccessfulFetchOpportunityPaymentSuccess = (
    response,
    reset = false,
  ) => {
    if (response?.data.length < limit) {
      setPaymentSuccessData(false);
    }
    setPaymentSuccessData((prevData) => {
      // const combined = [...prevData, ...response?.data];
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };

  const onSuccessfulFetchOpportunityDraft = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreDraft(false);
    }
    setDraftData((prevData) => {
      // const combined = [...prevData, ...response?.data];
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };
  const onSuccessfulFetchOpportunityPending = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMorePending(false);
    }

    setPendingData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };

  const onSuccessfulFetchOpportunityCancelled = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreCancelled(false);
    }

    setCancelledData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };

  const onSuccessfulFetchOpportunityLost = (response, reset = false) => {
    if (response?.data.length < limit) {
      setHasMoreLost(false);
    }

    setLostData((prevData) => {
      const combined = reset
        ? response?.data
        : [...prevData, ...response?.data];
      const unique = Array.from(
        new Map(combined.map((item) => [item.invoice_no, item])).values(),
      );
      return unique;
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchRfq({ module_type: "RFQ" });
      await fetchContract();
    };

    fetchData();
  }, []);

  const deleteRecordById = (id) => {
    deleteRecord({ id: id }, onDeleteSuccess, onDeleteError);
  };

  const onDeleteSuccess = (res) => {
    toast.success(res?.message || "Record deleted successfully");
    setPage({
      draft: 1,
      won: 1,
      paymentSuccess: 1,
      lost: 1,
      pending: 1,
      cancelled: 1,
    });
    handleClearFilter();
  };

  const onDeleteError = (err) => {
    toast.error(err?.message || "Failed to delete the record");
  };

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const filtersToSave = {
      search,
      salesHeadFilter,
      selectedStatus,
      contractFilter,
      sortOption,
      orderTypeFilter,
      paymentTypeFilter,
      vendorFilter,
      vendorName,
      selectedProductsFilter,
      startDate: startDate ? startDate.toISOString() : null,
      endDate: endDate ? endDate.toISOString() : null,
      publishedFrom: publishedFrom ? publishedFrom.toISOString() : null,
      publishedTo: publishedTo ? publishedTo.toISOString() : null,
      dueDateFrom: dueDateFrom ? dueDateFrom.toISOString() : null,
      dueDateTo: dueDateTo ? dueDateTo.toISOString() : null,
      globalTotal,
    };
    localStorage.setItem("opportunity_filters", JSON.stringify(filtersToSave));
  }, [
    search,
    salesHeadFilter,
    selectedStatus,
    contractFilter,
    sortOption,
    orderTypeFilter,
    paymentTypeFilter,
    vendorFilter,
    vendorName,
    selectedProductsFilter,
    startDate,
    endDate,
    publishedFrom,
    publishedTo,
    dueDateFrom,
    dueDateTo,
    globalTotal,
  ]);

  useEffect(() => {
    const hasAnyResponse = !!(
      wonres ||
      draftres ||
      penddingres ||
      cancelledres ||
      lostres
    );
    if (!hasAnyResponse) return;
    const statusTotals = {
      WON: wonres?.pagination?.totalRfqs || 0,
      DRAFT: draftres?.pagination?.totalRfqs || 0,
      PENDING: penddingres?.pagination?.totalRfqs || 0,
      CANCELLED: cancelledres?.pagination?.totalRfqs || 0,
      LOST: lostres?.pagination?.totalRfqs || 0,
    };
    // Only sum totals for statuses that are actually part of the active filter,
    // otherwise stale totals from previously selected statuses inflate the count.
    const total =
      selectedStatus.length > 0
        ? selectedStatus.reduce(
          (sum, status) => sum + (statusTotals[status] || 0),
          0,
        )
        : Object.values(statusTotals).reduce((sum, val) => sum + val, 0);
    setFilteredTotal(total);
    const isActivelyFiltered = !!(
      search ||
      salesHeadFilter ||
      contractFilter ||
      orderTypeFilter ||
      paymentTypeFilter ||
      selectedStatus.length > 0 ||
      vendorFilter ||
      selectedProductsFilter.length > 0 ||
      startDate ||
      endDate ||
      publishedFrom ||
      publishedTo ||
      dueDateFrom ||
      dueDateTo
    );
    if (!isActivelyFiltered) {
      setGlobalTotal(total);
    }
  }, [wonres, draftres, penddingres, cancelledres, lostres, selectedStatus]);

  useEffect(() => {
    if (
      !loadingWon &&
      !loadingDraft &&
      !loadingPending &&
      !loadingCancelled &&
      !loadingLost
    ) {
      setIsContentSearching(false);
    }
  }, [loadingWon, loadingDraft, loadingPending, loadingCancelled, loadingLost]);

  useEffect(() => {
    const isPagination = page.won > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("WON")));
    if (!shouldFetch) return;
    setHasMoreWon(true); // Reset hasMore on filter/search change

    fetchOpportunityWon(
      {
        page: page.won,
        limit,
        status: "WON",
        sales_lead_email: salesHeadFilter || undefined,
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        published_date_from: publishedFrom
          ? moment(publishedFrom).format("YYYY-MM-DD")
          : undefined,
        published_date_to: publishedTo
          ? moment(publishedTo).format("YYYY-MM-DD")
          : undefined,
        due_date_from: dueDateFrom
          ? moment(dueDateFrom).format("YYYY-MM-DD")
          : undefined,
        due_date_to: dueDateTo
          ? moment(dueDateTo).format("YYYY-MM-DD")
          : undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
        order_type: orderTypeFilter || undefined,
        order_payment_type: paymentTypeFilter || undefined,
        vendor_id: vendorFilter || undefined,
        sku_ids:
          selectedProductsFilter.length > 0
            ? selectedProductsFilter.map((p) => p.sku_id)
            : undefined,
        ...sortOptionsMap[sortOption],
      },
      (response) => onSuccessfulFetchOpportunityWon(response, page.won === 1),
      setActiveStatuses((prev) =>
        prev.includes("WON") ? prev : [...prev, "WON"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.won, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.draft > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("DRAFT")));
    if (!shouldFetch) return;

    setHasMoreDraft(true); // Correct: this is for DRAFT data

    fetchOpportunityDraft(
      {
        page: page.draft,
        limit,
        status: "DRAFT",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        published_date_from: publishedFrom
          ? moment(publishedFrom).format("YYYY-MM-DD")
          : undefined,
        published_date_to: publishedTo
          ? moment(publishedTo).format("YYYY-MM-DD")
          : undefined,
        due_date_from: dueDateFrom
          ? moment(dueDateFrom).format("YYYY-MM-DD")
          : undefined,
        due_date_to: dueDateTo
          ? moment(dueDateTo).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
        order_type: orderTypeFilter || undefined,
        order_payment_type: paymentTypeFilter || undefined,
        vendor_id: vendorFilter || undefined,
        sku_ids:
          selectedProductsFilter.length > 0
            ? selectedProductsFilter.map((p) => p.sku_id)
            : undefined,
        ...sortOptionsMap[sortOption],
      },
      (response) =>
        onSuccessfulFetchOpportunityDraft(response, page.draft === 1),
      setActiveStatuses((prev) =>
        prev.includes("DRAFT") ? prev : [...prev, "DRAFT"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.draft, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.pending > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("PENDING")));
    if (!shouldFetch) return;
    setHasMorePending(true); // Reset hasMore on new search/filter

    fetchOpportunityPending(
      {
        page: page.pending,
        limit,
        status: "PENDING",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        published_date_from: publishedFrom
          ? moment(publishedFrom).format("YYYY-MM-DD")
          : undefined,
        published_date_to: publishedTo
          ? moment(publishedTo).format("YYYY-MM-DD")
          : undefined,
        due_date_from: dueDateFrom
          ? moment(dueDateFrom).format("YYYY-MM-DD")
          : undefined,
        due_date_to: dueDateTo
          ? moment(dueDateTo).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
        order_type: orderTypeFilter || undefined,
        order_payment_type: paymentTypeFilter || undefined,
        vendor_id: vendorFilter || undefined,
        sku_ids:
          selectedProductsFilter.length > 0
            ? selectedProductsFilter.map((p) => p.sku_id)
            : undefined,
        ...sortOptionsMap[sortOption],
      },
      (response) =>
        onSuccessfulFetchOpportunityPending(response, page.pending === 1),
      setActiveStatuses((prev) =>
        prev.includes("PENDING") ? prev : [...prev, "PENDING"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.pending, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.paymentSuccess > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 ||
          selectedStatus.includes("PAYMENT_SUCCESSFUL")));
    if (!shouldFetch) return;
    setHasMorePaymentSuccess(true); // Reset hasMore on new search/filter

    fetchOpportunityPaymentSuccess(
      {
        page: page.paymentSuccess,
        limit,
        status: "PAYMENT_SUCCESSFUL",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        published_date_from: publishedFrom
          ? moment(publishedFrom).format("YYYY-MM-DD")
          : undefined,
        published_date_to: publishedTo
          ? moment(publishedTo).format("YYYY-MM-DD")
          : undefined,
        due_date_from: dueDateFrom
          ? moment(dueDateFrom).format("YYYY-MM-DD")
          : undefined,
        due_date_to: dueDateTo
          ? moment(dueDateTo).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
        order_type: orderTypeFilter || undefined,
        order_payment_type: paymentTypeFilter || undefined,
        vendor_id: vendorFilter || undefined,
        sku_ids:
          selectedProductsFilter.length > 0
            ? selectedProductsFilter.map((p) => p.sku_id)
            : undefined,
        ...sortOptionsMap[sortOption],
      },
      (response) =>
        onSuccessfulFetchOpportunityPaymentSuccess(
          response,
          page.paymentSuccess === 1,
        ),
      setActiveStatuses((prev) =>
        prev.includes("PAYMENT_SUCCESSFUL")
          ? prev
          : [...prev, "PAYMENT_SUCCESSFUL"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.paymentSuccess, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.cancelled > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("CANCELLED")));
    if (!shouldFetch) return;
    setHasMoreCancelled(true); // Reset hasMore on new search/filter

    fetchOpportunityCancelled(
      {
        page: page.cancelled,
        limit,
        status: "CANCELLED",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        published_date_from: publishedFrom
          ? moment(publishedFrom).format("YYYY-MM-DD")
          : undefined,
        published_date_to: publishedTo
          ? moment(publishedTo).format("YYYY-MM-DD")
          : undefined,
        due_date_from: dueDateFrom
          ? moment(dueDateFrom).format("YYYY-MM-DD")
          : undefined,
        due_date_to: dueDateTo
          ? moment(dueDateTo).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
        order_type: orderTypeFilter || undefined,
        order_payment_type: paymentTypeFilter || undefined,
        vendor_id: vendorFilter || undefined,
        sku_ids:
          selectedProductsFilter.length > 0
            ? selectedProductsFilter.map((p) => p.sku_id)
            : undefined,
        ...sortOptionsMap[sortOption],
      },
      (response) =>
        onSuccessfulFetchOpportunityCancelled(response, page.cancelled === 1),
      setActiveStatuses((prev) =>
        prev.includes("CANCELLED") ? prev : [...prev, "CANCELLED"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.cancelled, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  useEffect(() => {
    const isPagination = page.lost > 1;
    const shouldFetch =
      isInitialLoad ||
      isPagination ||
      (isSearchClicked &&
        (selectedStatus.length === 0 || selectedStatus.includes("LOST")));
    if (!shouldFetch) return;
    setHasMoreLost(true);

    fetchOpportunityLost(
      {
        page: page.lost,
        limit,
        status: "LOST",
        created_date_from: startDate
          ? moment(startDate).format("YYYY-MM-DD")
          : undefined,
        created_date_to: endDate
          ? moment(endDate).format("YYYY-MM-DD")
          : undefined,
        published_date_from: publishedFrom
          ? moment(publishedFrom).format("YYYY-MM-DD")
          : undefined,
        published_date_to: publishedTo
          ? moment(publishedTo).format("YYYY-MM-DD")
          : undefined,
        due_date_from: dueDateFrom
          ? moment(dueDateFrom).format("YYYY-MM-DD")
          : undefined,
        due_date_to: dueDateTo
          ? moment(dueDateTo).format("YYYY-MM-DD")
          : undefined,
        sales_lead_email: salesHeadFilter || undefined,
        search: search?.length > 0 ? search : undefined,
        contract_type_id:
          contractFilter?.length > 0 ? contractFilter : undefined,
        order_type: orderTypeFilter || undefined,
        order_payment_type: paymentTypeFilter || undefined,
        vendor_id: vendorFilter || undefined,
        sku_ids:
          selectedProductsFilter.length > 0
            ? selectedProductsFilter.map((p) => p.sku_id)
            : undefined,
        ...sortOptionsMap[sortOption],
      },
      (response) => onSuccessfulFetchOpportunityLost(response, page.lost === 1),
      setActiveStatuses((prev) =>
        prev.includes("LOST") ? prev : [...prev, "LOST"],
      ),
    );
    setIsSearchClicked(false);
  }, [page.lost, limit, isSearchClicked, isViewOpen.isStatusUpdate]);

  const handleCopy_Quote = (selectedOption, rfq_id) => {
    navigate("/copy-quote", {
      state: {
        selectedCopy: selectedOption,
        rfqCopy: rfq_id,
      },
    });
  };

  const handleLoadMore = () => {
    if (hasMoreWon) {
      setPage((prev) => ({
        ...prev,
        won: prev.won + 1,
      }));
    }
  };

  // const handleLoadMoreDraft = () => {
  //   if (hasMoreDraft) {
  //     setPage((prev) => prev + 1);
  //   }
  // };
  const handleLoadMoreDraft = () => {
    if (hasMoreDraft) {
      setPage((prev) => ({
        ...prev,
        draft: prev.draft + 1,
      }));
    }
  };

  const handleLoadMorePending = () => {
    if (hasMorePending) {
      setPage((prev) => ({
        ...prev,
        pending: prev.pending + 1,
      }));
    }
  };

  const handleLoadMorePaymentSuccess = () => {
    if (hasMorePaymentSuccess) {
      setPage((prev) => ({
        ...prev,
        paymentSuccess: prev.paymentSuccess + 1,
      }));
    }
  };

  const handleLoadMoreCancelled = () => {
    if (hasMoreCancelled) {
      setPage((prev) => ({
        ...prev,
        cancelled: prev.cancelled + 1,
      }));
    }
  };

  const handleLoadMoreLost = () => {
    if (hasMoreLost) {
      setPage((prev) => ({
        ...prev,
        lost: prev.lost + 1,
      }));
    }
  };

  const isStatusActive = (status) =>
    selectedStatus.length === 0 || selectedStatus.includes(status);

  const statusCounts = {
    Pending: isStatusActive("PENDING")
      ? penddingres?.pagination?.totalRfqs || 0
      : 0,
    Won: isStatusActive("WON") ? wonres?.pagination?.totalRfqs || 0 : 0,
    // Payment_Successful: paymentSuccessres?.pagination?.totalRfqs || 0,
    Lost: isStatusActive("LOST") ? lostres?.pagination?.totalRfqs || 0 : 0,
    Cancelled: isStatusActive("CANCELLED")
      ? cancelledres?.pagination?.totalRfqs || 0
      : 0,
    Draft: isStatusActive("DRAFT") ? draftres?.pagination?.totalRfqs || 0 : 0,
  };

  // function openModalAndUpdateUrl(setViewStateFn, rfqId, key = "products", navigate) {
  //   // 1. Open the modal
  //   setViewStateFn({
  //     show: true,
  //     [key]: rfqId,
  //   });

  //   // 2. Use React Router navigation instead of pushState
  //   const currentPath = window.location.pathname;
  //   if (!currentPath.endsWith(`/${rfqId}`)) {
  //     navigate(`${currentPath}/${rfqId}`);
  //   }
  // }

  const handleViewClick = (row) => {
    setIsViewOpen({
      show: true,
      products: row,
    });

    const currentUrl = window.location.pathname;
    const newUrl = `${currentUrl}?${row.rfq_id}`;
    window.history.pushState(null, "", newUrl);
  };

  const ChangeStatusHandler = (rfqid, status) => {
    statusChange(
      { rfq_id: rfqid, rfq_status: status },
      onStatusSuccess,
      onStatusError,
    );
  };

  const onStatusSuccess = (response) => {
    toast.success(response.message);
    if (response.rfq_status === "WON") {
      console.log(
        "The opportunity ",
        response.rfq_id,
        " has been changed to ",
        response.rfq_status,
      );
      setWonRfqID(response.rfq_id);
      setShowCreateOrder(true);
    }
    triggerCardHighlight(response?.rfq_id);
    handleClose();
    handleClearFilter();
  };

  const onStatusError = (error) => {
    console.log("error?.products?.length", error?.products?.length);
    toast.error(error.message || "An error occurred during Status Change.");
    if (error?.products && error?.products?.length > 0) {
      setShowAddVendor(true);
      setErrorProducts(error?.products);
      setErrorRfq(error?.rfq_id);
    }
  };

  const openModal = (rfqid, status, Old_Status) => {
    let modalMessage = `Are you sure you want to change status to "${Old_Status} to ${status}"`;
    let modalTitle = "Change Status";
    let type = "success";
    let modalIcon = <IconRefreshDot stroke={1} />;
    let actionHandler = () => {
      ChangeStatusHandler(rfqid, status);
    };
    let action = "Change";
    setIsModalStatusOpen({
      show: true,
      action,
      message: modalMessage,
      onConfirm: actionHandler,
      title: modalTitle,
      icon: modalIcon,
      type: type,
    });
  };

  const handleWonSuccess = (rfqId) => {
    console.log("createOrderRfqId", createOrderRfqId);
    setCreateOrderRfqId(rfqId);
    setShowCreateOrderRfq(true);
  };

  const handleDownloadExcel = async () => {
    try {
      const response = await axiosInstance.post(
        API_ENDPOINTS.OPPORTUNITY_EXCEL_DOWNLOAD,
        {
          // filters
          search: search?.length > 0 ? search : undefined,
          sales_lead_email: salesHeadFilter || undefined,
          contract_type_id:
            contractFilter?.length > 0 ? contractFilter : undefined,
          status: selectedStatus?.length > 0 ? selectedStatus : undefined,
          created_date_from: startDate
            ? moment(startDate).format("YYYY-MM-DD")
            : undefined,
          created_date_to: endDate
            ? moment(endDate).format("YYYY-MM-DD")
            : undefined,
          ...sortOptionsMap[sortOption],
        },
        {
          responseType: "blob",
        },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `opportunity_${moment().format("YYYY-MM-DD")}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Excel download failed:", error);
      toast.error("Excel download failed. Please try again.");
    }
  };
  return (
    <>
      {isContentSearching && <Loader />}

      {/* {isCopyQuoteOpen.show && (
        <CopyEmailDialog
          module_id={isCopyQuoteOpen.rfq_id}
          show={isCopyQuoteOpen.show}
          onCopy={handleCopy_Quote}
          setShow={setIsCopyQuoteOpen}
        />
      )} */}

      {/* <DeletePopup/> */}
      <RfqWonPopup
        show={showAddVendor}
        onClose={() => setShowAddVendor(false)}
        products={errorProducts}
        rfqId={errorRfq}
        onWonSuccess={handleWonSuccess}
      />

      <CreateOrderEditRfq
        show={showCreateOrderRfq}
        onClose={() => {
          setShowCreateOrderRfq(false);
          setCreateOrderRfqId(null);
        }}
        rfqId={createOrderRfqId}
      />

      <CreateOrder
        show={showCreateOrder}
        onClose={() => setShowCreateOrder(false)}
        rfqId={WonRfqID}
      />
      <ComanConfirmationModal
        show={isModalStatusOpen.show}
        onHide={() => {
          setIsModalStatusOpen({ ...isModalStatusOpen, show: false });
          // setIsOpen(false);
        }}
        title={isModalStatusOpen.title}
        message={isModalStatusOpen.message}
        onConfirm={isModalStatusOpen.onConfirm}
        icon={isModalStatusOpen.icon}
        type={isModalStatusOpen.type}
      />

      {isEmailHistoryOpen.show && (
        <EmailHistory
          show={isEmailHistoryOpen.show}
          rfq_id={isEmailHistoryOpen.rfq_id}
          setShow={setIsEmailHistoryOpen}
          username={user.username}
          // setShow={setIsEmailQuoteOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}

      {/* {isViewOpen.show && ( */}
      <View_DetailsOpportunity
        // show={isViewOpen.show}
        // opportunity={isViewOpen.products}
        // setShow={setIsViewOpen}
        isStatusUpdate={isViewOpen.isStatusUpdate}
        onStatusUpdate={() =>
          setIsViewOpen((prev) => ({ ...prev, isStatusUpdate: true }))
        }
        triggerCardHighlight={triggerCardHighlight}
      />
      {/* )} */}

      {isEmailQuoteOpen.show && (
        <EmailQuoteDialog
          username={user.username}
          show={isEmailQuoteOpen.show}
          rfq_id={isEmailQuoteOpen.rfq_id}
          Quote_No={isEmailQuoteOpen.Quote_No}
          setShow={setIsEmailQuoteOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}

      {isEmaillOpen.show && (
        <KOorCustomerEmailDialog
          pagetitle={isEmaillOpen.title}
          toEmail={isEmaillOpen.toEmail}
          toName={isEmaillOpen.toName}
          RFQID={isEmaillOpen.RFQID}
          show={isEmaillOpen.show}
          skuData={isEmaillOpen.skuData}
          row={isEmaillOpen.row}
          defaultSubject={isEmaillOpen.defaultSubject}
          Quote_No={isEmaillOpen.Quote_No}
          setShow={setIsEmaillOpen}
          setIsSuccsessModalOpen={setIsSuccsessModalOpen}
        />
      )}

      {isModalOpen.show && (
        <SKU_Version_POPUP
          rfqSku={rfqSku}
          show={isModalOpen.show}
          setShow={setIsModalOpen}
        />
      )}

      {isHistoryOpen.show && (
        <GetRFQHistoryPOP_UP
          rfqSku={rfqSku}
          show={isHistoryOpen.show}
          setShow={setIsHistoryOpen}
        />
      )}

      {isExcelOpen.show && (
        <ExcelDialog
          show={isExcelOpen.show}
          setShow={setIsExcelOpen}
          onDownload={(fields) => {
            handleGenerateExcel(fields);
            setIsExcelOpen({ show: false });
          }}
        />
      )}

      <SuccsessMsgModal
        show={isSuccsessModalOpen.show}
        onHide={() =>
          setIsSuccsessModalOpen(
            { ...isSuccsessModalOpen, show: false },
            // navigate("/dashboard")
          )
        }
        title={isSuccsessModalOpen?.title}
        btntext={isSuccsessModalOpen?.btntext}
        message={isSuccsessModalOpen?.message}
      />
      {/* new filtter */}

      <div className="page-header d-print-none mb-3">
        <div className="row align-items-center justify-content-between">
          <div className="col">
            <h2 className="page-title">Opportunities</h2>
          </div>
          <div className="col-auto">
            <div
              className="view-toggle d-inline-flex align-items-center gap-1 board-list-toggle"
              style={{
                backgroundColor: "#ffffff",
                borderRadius: "6px",
                border: "1px solid #e0e0e0",
                padding: "3px",
              }}
            >
              <Button
                onClick={() => handleListViewChange(false)}
                className="d-flex align-items-center gap-1 border-0"
                style={{
                  backgroundColor: !isListView ? "#fe6338" : "transparent",
                  color: !isListView ? "#fff" : "#6c757d",
                  boxShadow: "none",
                  borderRadius: "4px",
                  fontWeight: 500,
                  fontSize: "13px",
                  padding: "8px 10px",
                  lineHeight: 1.2,
                  minWidth: "auto",
                }}
              >
                <IconLayoutGridFilled size={14} /> Board
              </Button>
              <Button
                onClick={() => handleListViewChange(true)}
                className="d-flex align-items-center gap-1 border-0"
                style={{
                  backgroundColor: isListView ? "#fe6338" : "transparent",
                  color: isListView ? "#fff" : "#6c757d",
                  boxShadow: "none",
                  borderRadius: "4px",
                  fontWeight: 500,
                  fontSize: "13px",
                  padding: "8px 10px",
                  lineHeight: 1.2,
                  minWidth: "auto",
                }}
              >
                <IconLayoutListFilled size={14} /> List
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Shared filter bar — applies to BOTH views */}
      <Card className="mb-2 shadow-sm">
        <Card.Body className="p-3">
          <Form
            className="d-flex align-items-center gap-4 position-relative"
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSearch();
              }
            }}
          >
            <InputGroup>
              <Form.Control
                ref={searchInputRef}
                className="bg-light shadow-none"
                placeholder="Search anything..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                autoComplete="off"
              />
              <InputGroup.Text className="bg-white border-start-0">
                <IconSearch stroke={2} />
              </InputGroup.Text>
            </InputGroup>

            <div className="d-flex align-items-center gap-2 border_filter">
              {(() => {
                const filterCount = [
                  search,
                  salesHeadFilter,
                  contractFilter,
                  orderTypeFilter,
                  paymentTypeFilter,
                  vendorFilter,
                  selectedProductsFilter.length > 0,
                  selectedStatus.length > 0,
                  startDate || endDate,
                  publishedFrom || publishedTo,
                  dueDateFrom || dueDateTo,
                ].filter(Boolean).length;

                return (
                  <Button
                    ref={filterBtnRef}
                    className="filter-btn"
                    onClick={() => setShowFiltersModal((p) => !p)}
                  >
                    <IconFilter size={16} />
                    <span>Filters</span>
                    {filterCount > 0 && (
                      <span
                        className="ms-1 badge rounded-pill text-white"
                        style={{
                          backgroundColor: "#fe6338",
                          fontSize: 11,
                          padding: "2px 6px",
                        }}
                      >
                        {filterCount}
                      </span>
                    )}
                  </Button>
                );
              })()}

              <Dropdown onSelect={handleSortChange}>
                <Dropdown.Toggle className="filter-btn">
                  <IconArrowsSort size={16} />
                  Sort:{" "}
                  {sortOptionsMap[sortOption]?.label || "Recently Updated"}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey="recently_updated">
                    Recently updated
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="created_date_closest">
                    Created date closest to now
                  </Dropdown.Item>
                  <Dropdown.Item eventKey="created_date_farthest">
                    Created date farthest from now
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>

            <div className="d-flex align-items-center gap-2 border_filter">
              <Button variant="warning" onClick={handleSearch}>
                <IconSearch size={16} /> Search
              </Button>
              <Button
                variant="outline-success"
                onClick={handleDownloadExcel}
                className="d-flex align-items-center gap-1"
              >
                <IconFileTypeXls size={16} /> Download
              </Button>
            </div>

            <Filters
              show={showFiltersModal}
              onHide={() => setShowFiltersModal(false)}
              anchorRef={filterBtnRef}
              initialValues={{
                salesLead: salesHeadFilter,
                contractVehicle: contractFilter,
                createdFrom: startDate,
                createdTo: endDate,
                orderType: orderTypeFilter,
                paymentType: paymentTypeFilter,
                status: selectedStatus.length === 1 ? selectedStatus[0] : "",
                vendor: vendorFilter,
                vendor_name: vendorName,
                selectedProducts: selectedProductsFilter,
                publishedFrom: publishedFrom,
                publishedTo: publishedTo,
                dueDateFrom: dueDateFrom,
                dueDateTo: dueDateTo,
              }}
              salesHeadData={SalesHead?.data || []}
              contractData={contractData?.data || []}
              matchCount={filteredTotal}
              totalCount={globalTotal}
              onApply={(values) => {
                setSalesHeadFilter(values.salesLead || "");
                setContractFilter(values.contractVehicle || "");
                setStartDate(values.createdFrom || null);
                setEndDate(values.createdTo || null);
                setOrderTypeFilter(values.orderType || "");
                setPaymentTypeFilter(values.paymentType || "");
                setSelectedStatus(values.status ? [values.status] : []);
                setVendorFilter(values.vendor || "");
                setVendorName(values.vendor_name || "");
                setSelectedProductsFilter(values.selectedProducts || []);
                setPublishedFrom(values.publishedFrom || null);
                setPublishedTo(values.publishedTo || null);
                setDueDateFrom(values.dueDateFrom || null);
                setDueDateTo(values.dueDateTo || null);
                setPage(() => ({
                  draft: 1,
                  won: 1,
                  lost: 1,
                  paymentSuccess: 1,
                  cancelled: 1,
                  pending: 1,
                }));
                setActiveStatuses([]);
                setIsInitialLoad(false);
                setIsContentSearching(true);
                setIsSearchClicked(true);
                setListViewSearchTrigger((prev) => prev + 1);
              }}
            />
          </Form>
        </Card.Body>
      </Card>

      {/* Active filter chips + counts */}
      <div className="d-flex justify-content-between gap-2 p-2 align-items-start">
        {(() => {
          const ORDER_TYPE_LABELS = {
            DS: "Dropship",
            CRK: "Consolidate / Repack",
            M: "Manufacturing",
            KIT: "Kit",
            S: "Stock",
          };
          const PAYMENT_TYPE_LABELS = {
            invoiced: "Invoiced",
            "pre-paid": "Prepaid",
            "post-paid": "Postpaid",
          };
          const STATUS_LABELS = {
            DRAFT: "Draft",
            PENDING: "Pending",
            WON: "Won",
            LOST: "Lost",
            CANCELLED: "Cancelled",
          };

          const triggerSearch = () => {
            setPage({
              draft: 1,
              won: 1,
              lost: 1,
              paymentSuccess: 1,
              cancelled: 1,
              pending: 1,
            });
            setActiveStatuses([]);
            setIsInitialLoad(false);
            setIsSearchClicked(true);
          };

          const findContractName = (id) => {
            for (const v of contractData?.data || []) {
              if (String(v.id) === String(id)) return v.name;
              for (const c of v.children || []) {
                if (String(c.id) === String(id)) return c.name;
              }
            }
            return String(id);
          };

          const chips = [];

          if (search)
            chips.push({
              key: "search",
              labelKey: "Search",
              labelValue: search,
              clear: () => {
                setSearch("");
                setSearchInput("");
                triggerSearch();
              },
            });

          if (salesHeadFilter)
            chips.push({
              key: "sales",
              labelKey: "Sales Lead",
              labelValue: salesHeadFilter,
              clear: () => {
                setSalesHeadFilter("");
                triggerSearch();
              },
            });

          if (contractFilter)
            chips.push({
              key: "contract",
              labelKey: "Contract",
              labelValue: findContractName(contractFilter),
              clear: () => {
                setContractFilter("");
                triggerSearch();
              },
            });

          if (orderTypeFilter)
            chips.push({
              key: "orderType",
              labelKey: "Order Type",
              labelValue: ORDER_TYPE_LABELS[orderTypeFilter] || orderTypeFilter,
              clear: () => {
                setOrderTypeFilter("");
                triggerSearch();
              },
            });

          if (paymentTypeFilter)
            chips.push({
              key: "paymentType",
              labelKey: "Payment Type",
              labelValue:
                PAYMENT_TYPE_LABELS[paymentTypeFilter] || paymentTypeFilter,
              clear: () => {
                setPaymentTypeFilter("");
                triggerSearch();
              },
            });

          if (selectedStatus.length > 0)
            chips.push({
              key: "status",
              labelKey: "Status",
              labelValue: selectedStatus
                .map((s) => STATUS_LABELS[s] || s)
                .join(", "),
              clear: () => {
                setSelectedStatus([]);
                triggerSearch();
              },
            });

          if (vendorFilter)
            chips.push({
              key: "vendor",
              labelKey: "Vendor",
              labelValue: vendorName || vendorFilter,
              clear: () => {
                setVendorFilter("");
                setVendorName("");
                triggerSearch();
              },
            });

          if (selectedProductsFilter.length > 0)
            chips.push({
              key: "products",
              labelKey: "Products",
              labelValue: `${selectedProductsFilter.length} selected`,
              clear: () => {
                setSelectedProductsFilter([]);
                triggerSearch();
              },
            });

          if (startDate || endDate)
            chips.push({
              key: "created",
              labelKey: "Created",
              labelValue: `${startDate ? moment(startDate).format("MM/DD/YY") : "?"} → ${endDate ? moment(endDate).format("MM/DD/YY") : "?"}`,
              clear: () => {
                setStartDate(null);
                setEndDate(null);
                triggerSearch();
              },
            });

          if (publishedFrom || publishedTo)
            chips.push({
              key: "published",
              labelKey: "Published",
              labelValue: `${publishedFrom ? moment(publishedFrom).format("MM/DD/YY") : "?"} → ${publishedTo ? moment(publishedTo).format("MM/DD/YY") : "?"}`,
              clear: () => {
                setPublishedFrom(null);
                setPublishedTo(null);
                triggerSearch();
              },
            });

          if (dueDateFrom || dueDateTo)
            chips.push({
              key: "dueDate",
              labelKey: "Due Date",
              labelValue: `${dueDateFrom ? moment(dueDateFrom).format("MM/DD/YY") : "?"} → ${dueDateTo ? moment(dueDateTo).format("MM/DD/YY") : "?"}`,
              clear: () => {
                setDueDateFrom(null);
                setDueDateTo(null);
                triggerSearch();
              },
            });

          if (chips.length === 0) return null;

          return (
            <div className="d-flex align-items-center gap-2 mb-2 flex-wrap px-1">
              <span
                className="fw-semibold small text-uppercase text-muted"
                style={{ letterSpacing: 0.5, fontSize: 11 }}
              >
                Active:
              </span>

              {chips.map((chip) => (
                <div
                  key={chip.key}
                  className="d-flex align-items-center gap-1 py-1 px-2 border rounded-pill bg-white"
                  style={{ fontSize: 12 }}
                >
                  <span className="text-muted">{chip.labelKey}:</span>
                  <span className="fw-semibold text-dark">
                    {chip.labelValue}
                  </span>
                  <IconX
                    size={12}
                    role="button"
                    onClick={chip.clear}
                    style={{
                      cursor: "pointer",
                      color: "#6c757d",
                      marginLeft: 2,
                    }}
                  />
                </div>
              ))}

              <Button
                variant="link"
                size="sm"
                className="clear-all-btn text-decoration-none btn btn-link btn-sm"
                style={{ fontSize: 12 }}
                onClick={handleClearFilter}
              >
                Clear all
              </Button>
            </div>
          );
        })()}

        <div
          className="d-flex align-items-center mb-2 px-1 text-muted fw-semibold"
          style={{ fontSize: "14px" }}
        >
          {(() => {
            const isActivelyFiltered = !!(
              search ||
              salesHeadFilter ||
              contractFilter ||
              orderTypeFilter ||
              paymentTypeFilter ||
              selectedStatus.length > 0 ||
              vendorFilter ||
              selectedProductsFilter.length > 0 ||
              startDate ||
              endDate ||
              publishedFrom ||
              publishedTo ||
              dueDateFrom ||
              dueDateTo
            );
            return isActivelyFiltered ? (
              <>
                <span className="text-orange me-1">{filteredTotal}</span> of{" "}
                {globalTotal} OPPORTUNITIES MATCH
              </>
            ) : (
              <>SHOWING ALL {globalTotal} OPPORTUNITIES</>
            );
          })()}
        </div>
      </div>

      {/* {isListView ? null : (
        <>
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title">Opportunities</h2>
              </div>
            </div>
          </div>

          <Card className="mb-3">
            <Card.Body>
              <Form
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    handleSearch();
                  }
                }}
              >
                <Row>
                  <Col lg={2} md={3} className="mb-2">
                    <Form.Label className="form-label">Search</Form.Label>
                    <InputGroup>
                      <InputGroup.Text>
                        <IconSearch />
                      </InputGroup.Text>
                      <Form.Control
                        ref={searchInputRef}
                        type="email"
                        placeholder="Search..."
                        required
                        name="name"
                        autoComplete="off"
                        value={search}
                        // onChange={handleSearch}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </InputGroup>
                  </Col>

                  <Col lg={2} md={3} className="mb-2">
                    <Form.Label className="form-label">
                      Sales Lead Email
                    </Form.Label>
                    <Form.Select
                      className="form-control"
                      value={salesHeadFilter}
                      onChange={handlesalesHeadFilter}
                    >
                      <option value={""}>All</option>
                      {SalesHead?.data?.map((sales,index) => (
                        <option key={index} value={sales?.email}>
                          {sales?.email}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col lg={2} md={3} className="mb-2">
                    <label className="form-label">Select Status</label>
                    <MultiSelect
                      value={selectedStatus}
                      options={statusOptions}
                      onChange={(e) => {
                        setSelectedStatus(e.value);
                      }}
                      optionLabel="label"
                      placeholder="All"
                      display="chip"
                      className="w-100"
                      panelHeaderTemplate={() => null}
                    />
                  </Col>
                  <Col lg={2} md={4} className="mb-2">
                    <Form.Label className="form-label">
                      Contract Vehicle
                    </Form.Label>
                    <TreeSelect
                      value={contractFilter ? String(contractFilter) : null}
                      onChange={(e) => setContractFilter(e.value ?? "")}
                      options={[
                        {
                          key: "",
                          label: "All",
                          selectable: true,
                          children: [],
                        },
                        ...(contractData?.data || []).map((vehicle) => ({
                          key: String(vehicle.id),
                          label: vehicle.name,
                          selectable: true,
                          children:
                            vehicle.children?.map((child) => ({
                              key: String(child.id),
                              label: child.name,
                              selectable: true,
                              children: [],
                            })) || [],
                        })),
                      ]}
                      placeholder="All"
                      filter
                      filterPlaceholder="Search contract vehicle"
                      style={{ width: "100%" }}
                    />
                  </Col>
                  <Col lg={2} md={3} className="mb-2">
                    <Form.Label className="form-label">
                      Contract Vehicle
                    </Form.Label>
                    <Form.Select
                      className="form-control"
                      value={contractFilter}
                      onChange={handleContractFilter}
                    >
                      <option selected value={""}>
                        All
                      </option>
                      {contractData?.data?.map((vehicle, index) => (
                        <option key={index} value={vehicle.id}>
                          {vehicle.name}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>

                  <Col lg={4} md={6} className="mb-2">
                    <div className="d-flex gap-2">
                      <div className="w-100">
                        <Form.Label className="form-label">
                          Created Date From
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconCalendarWeek />
                          </InputGroup.Text>
                          <DatePicker
                            className="form-control"
                            selected={startDate}
                            placeholderText="Select Date"
                            onChange={(date) => setStartDate(date)}
                            selectsStart
                            startDate={startDate}
                            endDate={endDate}
                            showMonthDropdown
                            showYearDropdown
                          // minDate={new Date()}
                          />
                        </InputGroup>
                      </div>

                      <div className="w-100">
                        <Form.Label className="form-label">
                          Created Date To
                        </Form.Label>
                        <InputGroup>
                          <InputGroup.Text>
                            <IconCalendarWeek />
                          </InputGroup.Text>
                          <DatePicker
                            className="form-control"
                            selected={endDate}
                            placeholderText="Select Date"
                            onChange={(date) => setEndDate(date)}
                            selectsEnd
                            startDate={startDate}
                            endDate={endDate}
                            minDate={startDate}
                            showMonthDropdown
                            showYearDropdown
                          />
                        </InputGroup>
                      </div>
                    </div>
                  </Col>
                  <Col lg={3} md={6} className="mb-2 mt-2">
                    <Form.Label className="form-label">&nbsp;</Form.Label>
                    <div className="d-flex gap-2">
                      <Button
                        style={{ minWidth: "auto" }}
                        variant="warning"
                        onClick={handleSearch}
                      >
                        Apply Filters
                      </Button>
                      <Button
                        style={{ minWidth: "auto" }}
                        variant="outline-secondary"
                        onClick={handleClearFilter}
                      >
                        Clear Filters
                      </Button>
                      <Button
                        style={{ minWidth: "auto" }}
                        onClick={() => setIsExcelOpen({ show: true })}
                        onClick={handleDownloadExcel}
                        variant="outline-success"
                      >
                        <IconFileTypeXls /> Download
                      </Button>
                    </div>
                  </Col>
                  <Form.Text>
                    Search by opportunity ID, contracting officer information,
                    description or any other relevant keyword.
                  </Form.Text>
                </Row>
              </Form>
            </Card.Body>
          </Card>
        </>
      )} */}

      {/* {isListView ? null : (
        <div className="d-flex align-items-center justify-content-end pt-2 pb-3 gap-3">
          <Dropdown onSelect={handleSortChange}>
            <Dropdown.Toggle variant="light" className="shortDropdown">
              <IconSortAscending />
              {sortOption ? sortOptionsMap[sortOption]?.label : "Sort By"}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item eventKey="recently_updated">
                Recently updated
              </Dropdown.Item>
              <Dropdown.Item eventKey="created_date_closest">
                Created date closest to now
              </Dropdown.Item>
              <Dropdown.Item eventKey="created_date_farthest">
                Created date farthest from now
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
          <div className="view-toggle d-flex align-items-center justify-content-end gap-1">
            <IconLayoutGridFilled
              onClick={() => setIsListView(false)}
              style={{
                cursor: "pointer",
                color: !isListView ? "#FE6338" : "#515151",
              }}
            />
            <IconLayoutListFilled
              onClick={() => setIsListView(true)}
              style={{
                cursor: "pointer",
                color: isListView ? "#FE6338" : "#515151",
              }}
            />
          </div>
        </div>
      )} */}
      <>
        {isListView ? (
          <TableListing
            externalFilters={{
              search,
              salesHeadFilter,
              contractFilter,
              selectedStatus,
              sortOption,
              orderTypeFilter,
              paymentTypeFilter,
              vendorFilter,
              selectedProductsFilter,
              startDate,
              endDate,
              publishedFrom,
              publishedTo,
              dueDateFrom,
              dueDateTo,
            }}
            searchTrigger={listViewSearchTrigger}
          />
        ) : (
          <div className="scroll_status">
            <div
              className={`status_row_sticky d-none d-md-block  ${isFixed ? "is-fixed" : ""
                }`}
              ref={stickyRef}
            >
              {(isInitialLoad || activeStatuses.includes("DRAFT")) && (
                <div className="status_item_box draft_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#818183ff" />
                    <span className="fw-bold">Draft</span>
                  </div>
                  <span className="status_count" style={{ color: "#818183ff" }}>
                    {draftres?.pagination?.totalRfqs}
                  </span>
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("PENDING")) && (
                <div className="status_item_box pending_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#F59F00" />
                    <span className="fw-bold">Pending</span>
                  </div>
                  <span className="status_count" style={{ color: "#F59F00" }}>
                    {penddingres?.pagination?.totalRfqs}
                  </span>
                </div>
              )}

              {/* {(isInitialLoad ||
                activeStatuses.includes("PAYMENT_SUCCESSFUL")) && (
                <div className="status_item_box won_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#23af6eff" />
                    <span className="fw-bold">Payment Successful</span>
                  </div>
                  <span className="status_count" style={{ color: "#23af6eff" }}>
                    {paymentSuccessres?.pagination?.totalRfqs}
                  </span>
                </div>
              )} */}

              {(isInitialLoad || activeStatuses.includes("WON")) && (
                <div className="status_item_box won_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#198754" />
                    <span className="fw-bold">Won</span>
                  </div>
                  <span className="status_count" style={{ color: "#198754" }}>
                    {wonres?.pagination?.totalRfqs}
                  </span>
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("LOST")) && (
                <div className="status_item_box closed_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#D63939" />
                    <span className="fw-bold">Lost</span>
                  </div>
                  <span className="status_count" style={{ color: "#D63939" }}>
                    {lostres?.pagination?.totalRfqs}
                  </span>
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("CANCELLED")) && (
                <div className="status_item_box closed_status">
                  <div className="status-heading">
                    <IconCircle size={18} stroke={5} color="#D63939" />
                    <span className="fw-bold">Cancelled</span>
                  </div>
                  <span className="status_count" style={{ color: "#D63939" }}>
                    {cancelledres?.pagination?.totalRfqs}
                  </span>
                </div>
              )}
            </div>

            <div
              className="stepper_status stepper_multicolor bs-stepper-header d-flex d-md-none"
              role="tablist"
            >
              {StatusList.map((step, idx) => (
                <div
                  className={`step ${currentStep === idx + 1
                      ? " active"
                      : idx + 1 < currentStep
                        ? "completed"
                        : ""
                    }`}
                  key={idx}
                >
                  <button
                    onClick={() => handleTabClick(idx + 1)}
                    type="button"
                    className="step-trigger"
                    role="tab"
                  >
                    <span className="bs-stepper-label d-flex align-items-center justify-content-between">
                      {step}
                      <span className="status_count ms-2">
                        {statusCounts[step] ?? 0}
                      </span>
                    </span>
                  </button>
                </div>
              ))}
            </div>

            <div className="status_row_box">
              {(isInitialLoad || activeStatuses.includes("DRAFT")) && (
                <div
                  className={`status_row_scroll ${currentStep === 5 ? "active_status_tab" : ""
                    }  Draft`}
                >
                  <>
                    {draftData?.length > 0 ? (
                      draftData?.map((row, index) => (
                        <Card
                          // className="status_item_card"
                          className={`status_item_card  ${highlightedOrders.includes(row.rfq_id)
                              ? "card-highlight "
                              : ""
                            }`}
                          key={index}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Opportunity ID:{" "}
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#818183ff" }}
                                  >
                                    {row.rfq_id}
                                  </p>
                                  {/* {userIsAdmin && (
                                    <span
                                      className="trash_card_item bg-red-lt"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        deleteRecordById(row.rfq_id);
                                      }}
                                    >
                                      <IconTrash stroke={1.5} size={19} />
                                    </span>
                                  )} */}
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Vehicle
                                </div>
                                <p className="label_card">
                                  {row?.ContractType?.name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Order Type</div>
                                <p className="label_card">
                                  {row?.order_type || "N/A"}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Order Payment Type
                                </div>
                                <p className="label_card text-capitalize">
                                  {row?.order_payment_type || "N/A"}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  // onClick={() =>
                                  //   openModalAndUpdateUrl(setIsViewOpen, row.rfq_id,navigate)
                                  // }
                                  // onClick={(e) => {
                                  //   setIsViewOpen({
                                  //     show: true,
                                  //     products: row,
                                  //   });
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation(); // prevent triggering the card click
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              {/* <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    HandlePDFClick(row);
                                  }}
                                >
                                  <IconFileTypePdf size={24} />{" "}
                                </span>
                                <b> Generate PDF</b>
                              </div> */}
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    dispatch(setOrderType(row?.order_type));

                                    openModal(row.rfq_id, "PENDING", "DRAFT");
                                  }}
                                >
                                  <IconSquareArrowRight size={24} />
                                </span>
                                <b>Next Stage</b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEmailHistoryOpen({
                                      show: true,
                                      rfq_id: row.rfq_id,
                                    });
                                  }}
                                >
                                  <IconMailSpark size={24} />
                                </span>
                                <b>Email</b>
                              </div>
                            </div>
                            <div className="rfq_card_row mt-3 justify-content-center">
                              <div className="total_amt_rfq">
                                <strong>Total Price:</strong>
                                <strong className="amt_bold">
                                  ${row?.total_cost_after_margin}
                                </strong>
                              </div>
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation(); // prevent triggering the card click
                                  navigate(`/edit-rfq/${row?.rfq_id}`);
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.product_count}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.attachment_count}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.notes_count}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>

                  {draftres?.data?.length >= 10 && hasMoreDraft && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleLoadMoreDraft}
                        disabled={loadingDraft}
                      >
                        <IconRotateClockwise size={18} />
                        {loadingDraft ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("PENDING")) && (
                <div
                  className={`status_row_scroll ${currentStep === 1 ? "active_status_tab" : ""
                    }  Pending`}
                >
                  <>
                    {pendingData?.length > 0 ? (
                      pendingData?.map((row, index) => (
                        <Card
                          // className="status_item_card"
                          className={`status_item_card  ${highlightedOrders.includes(row.rfq_id)
                              ? "card-highlight "
                              : ""
                            }`}
                          key={index}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Opportunity ID:
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#F59F00" }}
                                  >
                                    {row.rfq_id}
                                  </p>
                                  {/* {userIsAdmin && (
                                    <span
                                      className="trash_card_item bg-red-lt"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        deleteRecordById(row.rfq_id);
                                      }}
                                    >
                                      <IconTrash stroke={1.5} size={19} />
                                    </span>
                                  )} */}
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Vehicle
                                </div>
                                <p className="label_card">
                                  {row?.ContractType?.name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Order Type</div>
                                <p className="label_card">
                                  {row?.order_type || "N/A"}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Order Payment Type
                                </div>
                                <p className="label_card text-capitalize">
                                  {row?.order_payment_type || "N/A"}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  // onClick={(e) => {
                                  //   setIsViewOpen({
                                  //     show: true,
                                  //     products: row,
                                  //   });
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              {/* <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    HandlePDFClick(row);
                                  }}
                                >
                                  <IconFileTypePdf size={24} />{" "}
                                </span>
                                <b> Generate PDF</b>
                              </div> */}
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();

                                    dispatch(setOrderType(row?.order_type));

                                    // openModal(
                                    //   row.rfq_id,
                                    //   "PAYMENT_SUCCESSFUL",
                                    //   "PENDING"
                                    // );
                                    if (
                                      row?.order_payment_type === "pre-paid"
                                    ) {
                                      openModal(row.rfq_id, "WON", "PENDING");
                                    } else {
                                      openModal(row.rfq_id, "WON", "PENDING");
                                    }
                                  }}
                                >
                                  <IconSquareArrowRight size={24} />
                                </span>
                                <b>Next Stage</b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEmailHistoryOpen({
                                      show: true,
                                      rfq_id: row.rfq_id,
                                    });
                                  }}
                                >
                                  <IconMailSpark size={24} />
                                </span>
                                <b>Email</b>
                              </div>
                            </div>

                            <div className="rfq_card_row mt-3 justify-content-center">
                              <div className="total_amt_rfq">
                                <strong>Total Price:</strong>
                                <strong className="amt_bold">
                                  ${row?.total_cost_after_margin}
                                </strong>
                              </div>
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/edit-rfq/${row?.rfq_id}`);
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.product_count}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.attachment_count}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.notes_count}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>
                  {penddingres?.data?.length >= 10 && hasMorePending && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleLoadMorePending}
                        disabled={loadingPending}
                      >
                        <IconRotateClockwise size={18} />
                        {loadingPending ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}

              {/* {(isInitialLoad ||
                activeStatuses.includes("PAYMENT_SUCCESSFUL")) && (
                <div
                  className={`status_row_scroll ${
                    currentStep === 3 ? "active_status_tab" : ""
                  }  won`}
                >
                  <>
                    {paymentSuccessData?.length > 0 ? (
                      paymentSuccessData?.map((row, index) => (
                        <Card
                          // className="status_item_card"
                          className={`status_item_card  ${
                            highlightedOrders.includes(row.rfq_id)
                              ? "card-highlight "
                              : ""
                          }`}
                          key={index}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Opportunity ID:{" "}
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#23af6eff" }}
                                  >
                                    {row.rfq_id}
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Vehicle
                                </div>
                                <p className="label_card">
                                  {row?.ContractType?.name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Order Type</div>
                                <p className="label_card">{row?.order_type}</p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Order Payment Type
                                </div>
                                <p className="label_card text-capitalize">
                                  {row?.order_payment_type}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    HandlePDFClick(row);
                                  }}
                                >
                                  <IconFileTypePdf size={24} />{" "}
                                </span>
                                <b> Generate PDF</b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openModal(
                                      row.rfq_id,
                                      "WON",
                                      "PAYMENT_SUCCESSFUL"
                                    );
                                  }}
                                >
                                  <IconSquareArrowRight size={24} />
                                </span>
                                <b>Next Stage</b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEmailHistoryOpen({
                                      show: true,
                                      rfq_id: row.rfq_id,
                                    });
                                  }}
                                >
                                  <IconMailSpark size={24} />
                                </span>
                                <b>Email</b>
                              </div>
                            </div>

                            <div className="rfq_card_row mt-3 justify-content-center">
                              <div className="total_amt_rfq">
                                <strong>Total Cost:</strong>
                                <strong className="amt_bold">
                                  ${row?.total_cost_after_margin}
                                </strong>
                              </div>
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/edit-rfq/${row?.rfq_id}`);
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.RfqProducts.length}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.Attachments.length}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.section.reduce((acc, section) => {
                                    return acc + section.notes.length;
                                  }, 0)}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>

                  {paymentSuccessData?.data?.length >= 10 &&
                    hasMorePaymentSuccess && (
                      <div className="text-center mt-2">
                        <button
                          className="btn btn-outline-primary"
                          onClick={handleLoadMorePaymentSuccess}
                          disabled={loadingPaymentSuccess}
                        >
                          <IconRotateClockwise size={18} />
                          {loadingPaymentSuccess ? "Loading..." : "Load More"}
                        </button>
                      </div>
                    )}
                </div>
              )} */}

              {(isInitialLoad || activeStatuses.includes("WON")) && (
                <div
                  className={`status_row_scroll ${currentStep === 4 ? "active_status_tab" : ""
                    }  won`}
                >
                  <>
                    {wonData?.length > 0 ? (
                      wonData?.map((row, index) => (
                        <Card
                          // className="status_item_card"
                          className={`status_item_card  ${highlightedOrders.includes(row.rfq_id)
                              ? "card-highlight "
                              : ""
                            }`}
                          key={index}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Opportunity ID:{" "}
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#198754" }}
                                  >
                                    {row.rfq_id}
                                  </p>
                                  {/* {userIsAdmin && (
                                    <span
                                      className="trash_card_item bg-red-lt"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        deleteRecordById(row.rfq_id);
                                      }}
                                    >
                                      <IconTrash stroke={1.5} size={19} />
                                    </span>
                                  )} */}
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Vehicle
                                </div>
                                <p className="label_card">
                                  {row?.ContractType?.name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Order Type</div>
                                <p className="label_card">
                                  {row?.order_type || "N/A"}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Order Payment Type
                                </div>
                                <p className="label_card text-capitalize">
                                  {row?.order_payment_type || "N/A"}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  // onClick={(e) => {
                                  //   setIsViewOpen({
                                  //     show: true,
                                  //     products: row,
                                  //   });
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              {/* <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    HandlePDFClick(row);
                                  }}
                                >
                                  <IconFileTypePdf size={24} />{" "}
                                </span>
                                <b> Generate PDF</b>
                              </div> */}
                              {/* <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openModal(row.rfq_id, "LOST", "WON");
                                  }}
                                >
                                  <IconSquareArrowRight size={24} />
                                </span>
                                <b>Next Stage</b>
                              </div> */}
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEmailHistoryOpen({
                                      show: true,
                                      rfq_id: row.rfq_id,
                                    });
                                  }}
                                >
                                  <IconMailSpark size={24} />
                                </span>
                                <b>Email</b>
                              </div>
                            </div>

                            <div className="rfq_card_row mt-3 justify-content-center">
                              <div className="total_amt_rfq">
                                <strong>Total Price:</strong>
                                <strong className="amt_bold">
                                  ${row?.total_cost_after_margin}
                                </strong>
                              </div>
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/edit-rfq/${row?.rfq_id}`);
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.product_count}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.attachment_count}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.notes_count}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>

                  {wonres?.data?.length >= 10 && hasMoreWon && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleLoadMore}
                        disabled={loadingWon}
                      >
                        <IconRotateClockwise size={18} />
                        {loadingWon ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("LOST")) && (
                <div
                  className={`status_row_scroll ${currentStep === 5 ? "active_status_tab" : ""
                    }  Lost`}
                >
                  <>
                    {lostData?.length > 0 ? (
                      lostData?.map((row, index) => (
                        <Card
                          // className="status_item_card"
                          className={`status_item_card  ${highlightedOrders.includes(row.rfq_id)
                              ? "card-highlight "
                              : ""
                            }`}
                          key={index}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Opportunity ID:{" "}
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#D63939" }}
                                  >
                                    {row.rfq_id}
                                  </p>
                                  {/* {userIsAdmin && (
                                    <span
                                      className="trash_card_item bg-red-lt"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        deleteRecordById(row.rfq_id);
                                      }}
                                    >
                                      <IconTrash stroke={1.5} size={19} />
                                    </span>
                                  )} */}
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Vehicle
                                </div>
                                <p className="label_card">
                                  {row?.ContractType?.name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Order Type</div>
                                <p className="label_card">
                                  {row?.order_type || "N/A"}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Order Payment Type
                                </div>
                                <p className="label_card text-capitalize">
                                  {row?.order_payment_type || "N/A"}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  // onClick={(e) => {
                                  //   setIsViewOpen({
                                  //     show: true,
                                  //     products: row,
                                  //   });
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              {/* <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    HandlePDFClick(row);
                                  }}
                                >
                                  <IconFileTypePdf size={24} />{" "}
                                </span>
                                <b> Generate PDF</b>
                              </div> */}
                              {/* <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openModal(row.rfq_id, "CANCELLED", "LOST");
                                  }}
                                >
                                  <IconSquareArrowRight size={24} />
                                </span>
                                <b>Next Stage</b>
                              </div> */}
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEmailHistoryOpen({
                                      show: true,
                                      rfq_id: row.rfq_id,
                                    });
                                  }}
                                >
                                  <IconMailSpark size={24} />
                                </span>
                                <b>Email</b>
                              </div>
                            </div>

                            <div className="rfq_card_row mt-3 justify-content-center">
                              <div className="total_amt_rfq">
                                <strong>Total Price:</strong>
                                <strong className="amt_bold">
                                  ${row?.total_cost_after_margin}
                                </strong>
                              </div>
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/edit-rfq/${row?.rfq_id}`);
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.product_count}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.attachment_count}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.notes_count}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>

                  {lostres?.data?.length >= 10 && hasMoreLost && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleLoadMoreLost}
                        disabled={loadingLost}
                      >
                        <IconRotateClockwise size={18} />
                        {loadingLost ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}

              {(isInitialLoad || activeStatuses.includes("CANCELLED")) && (
                <div
                  className={`status_row_scroll ${currentStep === 6 ? "active_status_tab" : ""
                    }  Cancelled`}
                >
                  <>
                    {cancelledData?.length > 0 ? (
                      cancelledData?.map((row, index) => (
                        <Card
                          // className="status_item_card"
                          className={`status_item_card  ${highlightedOrders.includes(row.rfq_id)
                              ? "card-highlight "
                              : ""
                            }`}
                          key={index}
                          onClick={() => handleViewClick(row)}
                          style={{ cursor: "pointer" }}
                        >
                          <Card.Body>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card d-flex gap-2 align-items-center">
                                  Opportunity ID:{" "}
                                  <p
                                    className="label_card listing_label"
                                    style={{ color: "#D63939" }}
                                  >
                                    {row.rfq_id}
                                  </p>
                                  {/* {userIsAdmin && (
                                    <span
                                      className="trash_card_item bg-red-lt"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        deleteRecordById(row.rfq_id);
                                      }}
                                    >
                                      <IconTrash stroke={1.5} size={19} />
                                    </span>
                                  )} */}
                                </div>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Sales Lead</div>
                                <p className="label_card">
                                  {row?.sales_lead_name}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Contract Vehicle
                                </div>
                                <p className="label_card">
                                  {row?.ContractType?.name}
                                </p>
                              </div>
                            </div>
                            <div className="rfq_card_row">
                              <div className="rfq_item_card">
                                <div className="value_card">Order Type</div>
                                <p className="label_card">
                                  {row?.order_type || "N/A"}
                                </p>
                              </div>
                              <div className="rfq_item_card">
                                <div className="value_card">
                                  Order Payment Type
                                </div>
                                <p className="label_card text-capitalize">
                                  {row?.order_payment_type || "N/A"}
                                </p>
                              </div>
                            </div>

                            <div className="button-groups">
                              <div className="badge_btn">
                                <span
                                  // onClick={(e) => {
                                  //   setIsViewOpen({
                                  //     show: true,
                                  //     products: row,
                                  //   });
                                  // }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleViewClick(row);
                                  }}
                                >
                                  <IconEye size={24} />
                                </span>
                                <b> View Details </b>
                              </div>
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleSKUVERSION_OPEN(e, row.rfq_id);
                                  }}
                                >
                                  <IconHistoryToggle size={24} />
                                </span>
                                <b> Changes History</b>
                              </div>

                              {/* <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    HandlePDFClick(row);
                                  }}
                                >
                                  <IconFileTypePdf size={24} />{" "}
                                </span>
                                <b> Generate PDF</b>
                              </div> */}
                              {/* <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEmailHistoryOpen({
                                      show: true,
                                      rfq_id: row.rfq_id,
                                    });
                                  }}
                                >
                                  <IconMailSpark size={24} />
                                </span>
                                <b>Email</b>
                              </div> */}
                              <div className="badge_btn">
                                <span
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setIsEmailHistoryOpen({
                                      show: true,
                                      rfq_id: row.rfq_id,
                                    });
                                  }}
                                >
                                  <IconMailSpark size={24} />
                                </span>
                                <b>Email</b>
                              </div>
                            </div>

                            <div className="rfq_card_row mt-3 justify-content-center">
                              <div className="total_amt_rfq">
                                <strong>Total Price:</strong>
                                <strong className="amt_bold">
                                  ${row?.total_cost_after_margin}
                                </strong>
                              </div>
                            </div>
                            <div className="ftr_card_box">
                              <a
                                className="big_badge bg-cyan-lt"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(`/edit-rfq/${row?.rfq_id}`);
                                }}
                              >
                                <IconEdit width={18} height={18} /> Edit
                              </a>
                              <div className="rfq_lis_short">
                                <span>
                                  <IconBox stroke={1} />
                                  {row.product_count}
                                </span>
                                <span>
                                  <IconPaperclip stroke={1} />
                                  {row.attachment_count}
                                </span>
                                <span>
                                  <IconMessageCircle stroke={1} />
                                  {row.notes_count}
                                </span>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      ))
                    ) : (
                      <Card className="status_item_card">
                        <Card.Body>No data found.</Card.Body>
                      </Card>
                    )}
                  </>

                  {cancelledres?.data?.length >= 10 && hasMoreCancelled && (
                    <div className="text-center mt-2">
                      <button
                        className="btn btn-outline-primary"
                        onClick={handleLoadMoreCancelled}
                        disabled={loadingCancelled}
                      >
                        <IconRotateClockwise size={18} />
                        {loadingCancelled ? "Loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        )}
      </>
    </>
  );
};

export default OpportunityListing;
